import React from "react";
import { useMediaQuery } from "react-responsive";
import { Button } from "@speedoc/design-assets";
import useAppDownloadLink from "../../hooks/useAppDownloadLink";

export default function HouseCallDoctor({ content }) {
  const isMobile = useMediaQuery({ query: "(max-width: 992px)" });
  const downloadLink = useAppDownloadLink();

  return (
    <div id="houseCallDoctor">
      <div className="titleContainer">
        <div className="title">{content.title}</div>
        <div className="subtitle">{content.subtitle}</div>
      </div>
      <div className="contentContainer">
        {!isMobile ? (
          <>
            <div className="images">
              {content.images.length === 2 && (
                <>
                  <img src={content.images[0].media.url} className="image-1" alt="" />
                  <img src={content.images[1].media.url} className="image-2" alt="" />
                </>
              )}
            </div>
            <div className="contentRight">
              <div className="descriptionContainer">{content.descriptionDesktop}</div>
              {content.listDescription &&
                content.listDescription.length > 0 &&
                content.listDescription.map((desc, index) => (
                  <div className="content" key={index}>
                    <img alt="icon" src={desc.image?.url} />
                    <div className="contentDesc">
                      <div className="titleDesc">{desc.title}</div>
                      <div className="description">{desc.content}</div>
                    </div>
                  </div>
                ))}

              <div className="download">
                {content.downloadText && <div className="text">{content.downloadText}</div>}
                <a href={content.downloadLink || downloadLink}>
                  <Button className="button primary">
                    <span>{content.downloadButton || "Download the App"}</span>
                  </Button>
                </a>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="contentRight">
              <div className="descriptionContainer">{content.descriptionMobile}</div>
              {content.listDescription &&
                content.listDescription.length > 0 &&
                content.listDescription.map((desc, index) => (
                  <div className="content" key={index}>
                    <img alt="icon" src={desc.image?.url} />
                    <div className="contentDesc">
                      <div className="titleDesc">{desc.title}</div>
                      <div className="description">{desc.content}</div>
                    </div>
                  </div>
                ))}
            </div>
            <Button className="btnDownload">
              <a className="button secondary sm" href={downloadLink}>
                <span>{"Download the App"}</span>
              </a>
            </Button>
            <div className="images">
              {content.images.length === 2 && (
                <>
                  <img src={content.images[0].media.url} className="image-1" alt="" />
                  <img src={content.images[1].media.url} className="image-2" alt="" />
                </>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
